/**
 * Универсальный footer для страниц с кнопками действий
 * 
 * Закреплён внизу экрана (flex-shrink-0), не скроллится с контентом.
 * Требует родительский контейнер `flex flex-col h-screen`.
 * Единый источник правды для отступов: px-4 pb-10 pt-4
 * (pb-10 учитывает safe area на iPhone)
 */

import type { ReactNode } from 'react';

interface PageFooterProps {
  children: ReactNode;
  /** Дополнительные CSS-классы */
  className?: string;
}

export function PageFooter({ children, className = '' }: PageFooterProps): JSX.Element {
  return (
    <div className={`flex-shrink-0 bg-background px-4 pb-10 pt-4 ${className}`}>
      {children}
    </div>
  );
}